import { useContext } from 'react';
import { ProductContext } from "./ProductCard";

import styles from '../styles/styles.module.css'


export interface Props {
    className?: string
    nombre?: string,
    activeClass?: string;
    style?: React.CSSProperties
}

export const ProductNombre = ({ nombre, className, style }: Props) => {

    const { product } = useContext(ProductContext)
    return (
        <span
            className={`${styles.productDescription} ${className}`}
            style={style}
        >
            {nombre ? nombre : product.nombre}
        </span>
    );
}